<script lang="ts">
  import { i18n } from '../i18n/index.svelte';
  import { router } from '../stores/router.svelte';
  import { session } from '../stores/session.svelte';
  import PixelButton from '../components/PixelButton.svelte';
  import PixelAvatar from '../components/PixelAvatar.svelte';
  import WaveText from '../components/WaveText.svelte';

  const t = $derived(i18n.t);
</script>

<div class="view menu">
  <div class="menu__brand">
    <WaveText as="h1" class="menu__title" text="2K48" />
    <p class="menu__subtitle">{t.menu.subtitle}</p>
  </div>

  <nav class="menu__actions">
    <PixelButton variant="p2" icon="play" onclick={() => router.go('play')}
      >{t.menu.play}</PixelButton
    >
    <PixelButton variant="ghost" icon="trophy" onclick={() => router.go('rankings')}
      >{t.menu.rankings}</PixelButton
    >
    <PixelButton variant="ghost" icon="timer" onclick={() => router.go('history')}
      >{t.menu.history}</PixelButton
    >
    <PixelButton variant="ghost" icon="gear" onclick={() => router.go('settings')}
      >{t.menu.settings}</PixelButton
    >
  </nav>

  <footer class="menu__footer">
    <button class="menu__profile" onclick={() => router.go('profile')}>
      <PixelAvatar avatarId={session.profile?.avatarId ?? 0} size="sm" />
      <span class="menu__profile-name">{session.profile?.displayName ?? t.common.guest}</span>
    </button>

    <!-- Connection state is surfaced, not hidden: solo runs offline, so a
         failed connection is information rather than an error. -->
    <span class="menu__status" data-state={session.online === false ? 'off' : 'on'}>
      {session.online === false ? t.menu.offline : t.menu.online}
    </span>
  </footer>
</div>
